import React, { FC, useMemo } from 'react'

import {
  convertFromRaw,
  RawDraftContentState,
} from 'draft-js'

import {
  ITextEditor_HorizontalAlign,
} from '../types/texteditor'

import {
  IData_MagicTag_Render_Values,
} from '../types/schema/magic_tag'

import {
  getAlignClassname,
  exportHTML,
  getColorStyles,
  renderMagicString,
} from './utils'

interface RenderHTMLProps {
  value: RawDraftContentState,
  horizontalAlign?: ITextEditor_HorizontalAlign,
  preview?: boolean,
  values?: IData_MagicTag_Render_Values,
}

const RenderHTML: FC<React.PropsWithChildren<RenderHTMLProps>> = ({
  value,
  horizontalAlign,
  preview = false,
  values,
}) => {

  const {
    html,
    style,
  } = useMemo<{
    html: string,
    style: string,
  }>(() => {
    if(!value) return {
      html: '',
      style: '',
    }
    const contentState = convertFromRaw(value)
    let html = exportHTML(contentState)
    if(preview && values) {
      html = renderMagicString(html, values)
    }
    const style = getColorStyles(contentState)
    return {
      html,
      style,
    }
  }, [
    value,
    preview,
    values,
  ])

  return (
    <>
      {
        style && (
          <style dangerouslySetInnerHTML={{__html: style}} />
        )
      }
      <div
        className={`TextRender-root ${getAlignClassname(horizontalAlign || 'left')}`}
        dangerouslySetInnerHTML={{__html: html}}
      />
    </>
  )
}

export default RenderHTML